import { buildHeadersWithWidgetToken } from '@elfsight/lib-utils';
import type { Field, FormStatus } from '../../contexts';
import type { AdditionalData } from '../FormContainer';

const fetchRequestInit: RequestInit = {
  mode: 'cors',
  method: 'post'
};

export type FormatSubmitData = (
  data: Omit<SubmitOptions, 'url' | 'formatDataBeforeSubmit'>
) => unknown;

interface SubmitOptions {
  url: string;
  data: AdditionalData;
  fields: Record<string, Field>;
  formatSubmitData?: FormatSubmitData;
}

export type SubmitResponse = Promise<{
  status: FormStatus;
  data?: unknown;
}>;

export const submit = async ({
  url,
  data: derivedData,
  fields,
  formatSubmitData
}: SubmitOptions): SubmitResponse => {
  const { widget_token, ...otherDerivedData } = derivedData;

  const headers = buildHeadersWithWidgetToken(
    widget_token,
    new Headers({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    })
  );

  const data = formatSubmitData
    ? formatSubmitData({ data: derivedData, fields })
    : {
        fields: Object.values(fields),
        ...otherDerivedData
      };

  try {
    const response = await fetch(url, {
      ...fetchRequestInit,
      body: JSON.stringify(data),
      headers
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return {
      status: 'success'
    };
  } catch (err) {
    console.error('Form submit error: ', err);
    return {
      status: 'failed'
    };
  }
};
